import type { DateRange } from "./types";
const day = 86400000;
export function shiftDate(date: string, days: number): string {
  const d = new Date(`${date}T12:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}
export function validDate(value: string | null): value is string {
  if (!value || !/^\d{4}-\d{2}-\d{2}$/.test(value)) return false;
  const d = new Date(`${value}T12:00:00Z`);
  return !Number.isNaN(d.valueOf()) && d.toISOString().slice(0, 10) === value;
}
export function defaultRange(today = new Date()): DateRange {
  const local = `${today.getFullYear()}-${String(today.getMonth() + 1).padStart(2, "0")}-${String(today.getDate()).padStart(2, "0")}`;
  const end = shiftDate(local, -2);
  return { start: shiftDate(end, -27), end, compare: "previous" };
}
export function parseRange(
  params: URLSearchParams,
  today = new Date(),
): DateRange {
  const start = params.get("start"),
    end = params.get("end");
  return validDate(start) &&
    validDate(end) &&
    start <= end &&
    Date.parse(end) - Date.parse(start) <= 365 * day
    ? {
        start,
        end,
        compare: params.get("compare") === "none" ? "none" : "previous",
      }
    : defaultRange(today);
}
export function rangeParams(range: DateRange) {
  return new URLSearchParams({
    start: range.start,
    end: range.end,
    compare: range.compare,
  });
}
export function previousRange(range: DateRange) {
  const days =
    Math.round((Date.parse(range.end) - Date.parse(range.start)) / day) + 1;
  return {
    start: shiftDate(range.start, -days),
    end: shiftDate(range.start, -1),
  };
}
export function dateLabel(value: string) {
  return new Date(`${value}T12:00:00Z`).toLocaleDateString(undefined, {
    month: "short",
    day: "numeric",
    year: "numeric",
    timeZone: "UTC",
  });
}
